import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";

// This page is used as a target from the corp site, to allowing sending users
// to the app & initiating login immediately - if required. Once logged in,
// we simply redirect them to the root, replacing the login history entry.
export default withAuthenticationRequired(() => <Navigate to="/" replace />);
